import React, { FC, ReactElement, useCallback, useMemo, useState } from 'react';
import { InfoAltIcon, CloseIcon } from '@cherre-frontend/ui';
import {
  ConnectorStageBannerContainer,
  MessageContainer,
  MessageIconContainer,
  StyledButton,
} from './styles';
import { useFeatureFlag } from 'src/hooks/useFeatureFlag';
import { ConnectorStageBannerProps } from './model';
import { ConnectorStages } from 'src/products/connector/constants';

const ConnectorStageBanner: FC<ConnectorStageBannerProps> = ({
  stage,
}): ReactElement | null => {
  const canAddConnector = useFeatureFlag('ConnectorsCreateConnector');
  const [renderBanner, setRenderBanner] = useState(true);

  const message = useMemo(() => {
    if (stage === ConnectorStages.PUBLISH) {
      return 'Note: You may update the connector schedule but additional changes can only be made in the DEV environment. You can then promote your changes to the QC environment for further testing before moving them to production!';
    }

    if (stage === ConnectorStages.QC) {
      return 'Note: You may update the connector schedule but additional changes can only be made in the DEV environment. You can then promote your changes to the QC environment for further testing before moving them to production!';
    }

    return undefined;
  }, [stage]);

  const handleButtonClick = useCallback(() => {
    setRenderBanner(false);
  }, []);

  if (!message || !renderBanner || !canAddConnector) {
    return null;
  }

  return (
    <ConnectorStageBannerContainer>
      <MessageIconContainer>
        <InfoAltIcon
          sx={{
            height: '20px',
            width: '20px',
            color: '#AD5D00',
          }}
        />
        <MessageContainer>{message}</MessageContainer>
      </MessageIconContainer>
      <StyledButton onClick={handleButtonClick}>
        <CloseIcon
          sx={{
            height: '15px',
            width: '15px',
            color: '#AD5D00',
          }}
        />
      </StyledButton>
    </ConnectorStageBannerContainer>
  );
};

export default ConnectorStageBanner;
